export const FETCHED = 'PAGE_FETCHED'
